import { useEffect, useState } from "react";

import { ClickableIcon } from "components/Icon/ClickableIcon";
import { useTranslation } from "i18n";
import { copyToClipBoard } from "utils";

export const Secret = ({ secret }: { secret: string }) => {
  const t = useTranslation();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timeout = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timeout);
  }, [copied]);

  const text = `${secret.slice(0, 8)}...`;
  return (
    <div className="flex items-center gap-8">
      <p className="whitespace-nowrap overflow-x-auto">{text}</p>
      <ClickableIcon
        name={copied ? "check" : "copy"}
        onClick={() =>
          void copyToClipBoard(
            secret,
            t("copiable_text.copiable_text.copied"),
          ).then(() => setCopied(true))
        }
      />
    </div>
  );
};
